const initialState = [
    {
        id: 'branch-1',
        i18n: 'Ja',
        isActive: true,
        slots: [
            'slot-1-01',
            'slot-1-02',
            'slot-1-03',
            'slot-1-04',
            'slot-1-05',
            'slot-1-06',
            'slot-1-07',
            'slot-1-08',
            'slot-1-09',
            'slot-1-10'
        ]
    }, {
        id: 'branch-2',
        i18n: 'Nein',
        isActive: false,
        slots: [
            'slot-2-01',
            'slot-2-02',
            'slot-2-03',
            'slot-2-04',
            'slot-2-05',
            'slot-2-06',
            'slot-2-07',
            'slot-2-08',
            'slot-2-09',
            'slot-2-10'
        ]
    }
];

/*
 * Reducer to represent the branches
 *
 */
const branches = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_CURRENT_BRANCH':
            return state.map(branch => 
                Object.assign({}, branch, { isActive: branch.id === action.id })
            );
        default:
            return state;
    }
};

export default branches;